import {
  TriggerMetadataMap,
  TRIGGER_METADATA,
  WORKFLOW_TRIGGERS,
} from 'modules/workflows/constants';
import { CreationOnlyCheckbox } from 'modules/workflowNodeEditors/components/StartNodeEditor/resourceComponents/CreationOnlyCheckbox';

export const START_NODE_EDITOR_TEST_ID = 'start-node-editor';

export const API_CALL_SOURCE_TEST_ID = 'api-call-entry-source';
export const EVENT_ENTRY_SOURCE_TEST_ID = 'event-entry-source';
export const OTHER_JOURNEY_SOURCE_TEST_ID = 'other-journey-entry-source';
export const SCHEDULE_SOURCE_TEST_ID = 'schedule-entry-source';

export const TRIGGER_METADATA_FOR_START_TILE: TriggerMetadataMap = {
  ...TRIGGER_METADATA,
  [WORKFLOW_TRIGGERS.FIELD_CHANGED]: {
    ...TRIGGER_METADATA[WORKFLOW_TRIGGERS.FIELD_CHANGED],
    TriggerForm: CreationOnlyCheckbox,
  },
};
